export const capitalizeFilter = (value: string): string => {
    if (value !== null && value !== undefined) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    } else {
        return value;
    }
};
